/**
 * Constants for MFACodeContainer component
 */

/**
 * Wait period in seconds before resend link becomes available
 */
export const MFA_WAIT_SECONDS = 30;

/**
 * Code expiration time in minutes (login/forgot MFA flows)
 */
export const MFA_EXPIRATION_MINUTES = 15;

/**
 * Registration OTP expiration — email factor (matches notification copy)
 */
export const EMAIL_OTP_EXPIRATION_MINUTES = 10;

/**
 * Registration OTP expiration — SMS/phone factor (matches notification copy)
 */
export const SMS_OTP_EXPIRATION_MINUTES = 5;

export function getOtpExpirationMinutes(factorType?: string): number {
  const normalized = factorType?.toLowerCase() ?? "email";
  if (normalized === "sms" || normalized === "phone") {
    return SMS_OTP_EXPIRATION_MINUTES;
  }
  return EMAIL_OTP_EXPIRATION_MINUTES;
}
